"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.answers = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _radioGroupStandard = _interopRequireDefault(require("../../components/radioGroupStandard"));

var _lodash = _interopRequireDefault(require("lodash"));

var Pregnancy = function Pregnancy(props) {
  return /*#__PURE__*/_react["default"].createElement(_radioGroupStandard["default"], props);
};

Pregnancy.defaultProps = {
  label: 'Are you currently pregnant?',
  answerLabels: ['Yes', 'No', 'I prefer not to answer']
};
Pregnancy.propTypes = {
  name: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func.isRequired
};

var _default = function _default(_ref) {
  var label = _ref.label,
      input = _ref.input,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["label", "input"]);
  return /*#__PURE__*/_react["default"].createElement(Pregnancy, (0, _extends2["default"])({}, props, input));
};

exports["default"] = _default;
var answers = Pregnancy.defaultProps.answerLabels.map(function (answer) {
  return _lodash["default"].snakeCase(answer);
});
exports.answers = answers;